export default __webpack_public_path__ + "static/keine-trendstoffe-augenpermanence-4810338ec092e7b75d3b18185efe2036.jpg";